import trusted1 from "../../assets/features/feature-1.png";
import trusted2 from "../../assets/features/feature-2.png";
import trusted3 from "../../assets/features/feature-3.png";
import trusted4 from "../../assets/features/feature-4.png";

export const trustedPaperContent = {
    title: "We Are Trusted Paper Packing Company",

    // Slider Images (duplicated for loop)
    sliderImages: [
        trusted1,
        trusted2,
        trusted3,
        trusted4,
        trusted1,
        trusted2,
        trusted3,
        trusted4,
    ],

    sliderSettings: {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnHover: false,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
    },

    cards: [
        {
            title:
                "Premium Cigarette Packaging Solutions for Global Tobacco Brands",
            desc:
                "We manufacture tipping paper, inner frame material, hot stamping foil, and cigarette seals, trusted by 50+ global brands for quality, consistency, and precision.",
        },
        {
            title:
                "Innovating Since 2004 – Your Reliable Tipping Paper Partner",
            desc:
                "Our advanced converting facilities combine German technology and eco-friendly materials to deliver odor-free, high-speed, and visually refined tipping papers.",
        },
        {
            title:
                "Anti-Counterfeit Tipping Papers with Custom Designs",
            desc:
                "Built-in security features such as laser perforation, watermarking, and LIP options ensure fire safety and protect brand authenticity.",
        },
        {
            title:
                "Tamper-Evident Cigarette Seals with Precision Adhesion",
            desc:
                "Equipped with heat-activated glue and printable QR codes, our seals ensure tamper detection and track & trace compliance for modern packaging needs.",
        },
        {
            title:
                "Beyond ISO 9001 – Our Multi-Layer Quality Assurance",
            desc:
                "Every batch undergoes porosity, tensile, and adhesion testing, with microbial control and zero-defect protocols ensuring consistent premium output.",
        },
        {
            title:
                "From Prototype to Bulk Order – Tailored for Your Market",
            desc:
                "We offer 3D embossing, holographic effects, and region-specific adaptations such as EU tax stamps or China-style flip-top cartons.",
        },
    ],
};